import axios from 'axios'
import { CS_BASE_URL, CS_INBOX, CS_SOURCE } from './config'

// 客服系统访客端接口：独立实例，不带落地页自己的请求配置
const http = axios.create({
  baseURL: `${CS_BASE_URL}/public/api/v1/inboxes/${CS_INBOX}/contacts`,
  timeout: 20000,
  headers: { 'X-PG-Source': CS_SOURCE }
})

// 新建匿名访客：不带任何资料，名字由客服系统按 IP 生成
export const createVisitor = () => http.post('', {}).then(r => r.data)

// 访客是否还在（坐席可能删了）；只有明确 404 才算不在，网络错误按还在处理
export const visitorExists = sourceId =>
  http.get(`/${sourceId}`).then(
    () => true,
    e => !(e.response && e.response.status === 404)
  )

export const listConversations = sourceId => http.get(`/${sourceId}/conversations`).then(r => r.data)

export const createConversation = sourceId => http.post(`/${sourceId}/conversations`, {}).then(r => r.data)

// 不传 before 返回最新 20 条；传 before 返回更早的 20 条；按时间正序
export const listMessages = (sourceId, convId, before) =>
  http
    .get(`/${sourceId}/conversations/${convId}/messages`, { params: before ? { before } : {} })
    .then(r => r.data)

export const sendText = (sourceId, convId, content, echoId) =>
  http.post(`/${sourceId}/conversations/${convId}/messages`, { content, echo_id: echoId }).then(r => r.data)

export const sendFile = (sourceId, convId, file, echoId, onProgress) => {
  const form = new FormData()
  form.append('echo_id', echoId)
  form.append('attachments[]', file, file.name)
  return http
    .post(`/${sourceId}/conversations/${convId}/messages`, form, {
      timeout: 120000,
      onUploadProgress: e => onProgress && e.total && onProgress(Math.round((e.loaded / e.total) * 100))
    })
    .then(r => r.data)
}

export const updateLastSeen = (sourceId, convId) =>
  http.post(`/${sourceId}/conversations/${convId}/update_last_seen`).catch(() => {})

// 被坐席禁言时服务端拒收：403 + contact_blocked
export const isMutedError = e =>
  Boolean(e && e.response && e.response.status === 403 && e.response.data && e.response.data.error === 'contact_blocked')

// 网络错误、超时、5xx 值得重试；4xx（禁言、文件类型不对）重试也没用
export const isRetryable = e => !e || !e.response || e.response.status >= 500

// 发太快被服务端限流（429）：等一会儿手动重发即可
export const isRateLimited = e => Boolean(e && e.response && e.response.status === 429)
